import { GoogleAnalytics4 } from "@utils/google-analytics-4";
import autobind from "autobind-decorator";
import React from "react";
import type { ReactNode } from "react";
import { InView } from "react-intersection-observer";
import "./bank-logos-cloud.scss";

const bankNames = {
	cetelem: "Magyar Cetelem Bank",
	cib: "CIB Bank",
	cofidis: "Cofidis",
	erste: "Erste Bank",
	granit: "Gránit Bank",
	kh: "K&H Kereskedelmi és Hitelbank",
	mbh: "MBH Bank",
	otp: "Otp Bank",
	provident: "Provident Pénzügyi Zrt.",
	raiffeisen: "Raiffeisen Bank",
	unicredit: "UniCredit Bank",
};

const mortgageLinks = {
	// cetelem: undefined, Kiszedve, Józsi jelezte,hogy nincs a Cetelemnek JZH terméke
	cib: `/cib/lakashitel/`,
	erste: `/erste/lakashitel/`,
	// granit: undefined, kiszedve, Józsi jelezte, hogy egyelőre nincs szerződésünk
	kh: `/kh/lakashitel/`,
	mbh: `/mbh/lakashitel/`,
	otp: `/otp/lakashitel/`,
	raiffeisen: `/raiffeisen/lakashitel/`,
	unicredit: `/unicredit/lakashitel/`,
};

const personalLoanLinks = {
	cib: `/cib/szemelyi-kolcson/`,
	cetelem: undefined,
	// cofidis: undefined,
	erste: `/erste/szemelyi-kolcson/`,
	// granit: undefined,
	kh: `/kh/szemelyi-kolcson/`,
	mbh: `/mbh/szemelyi-kolcson/`,
	otp: `/otp/szemelyi-kolcson/`,
	// provident: undefined,
	raiffeisen: `/raiffeisen/szemelyi-kolcson/`,
	unicredit: `/unicredit/szemelyi-kolcson/`,
};

const retailAccountLinks = {
	cib: `/cib/bankszamla/`,
	erste: `/erste/bankszamla/`,
	granit: undefined,
	kh: `/kh/bankszamla/`,
	mbh: `/mbh/bankszamla/`,
	otp: `/otp/bankszamla/`,
	raiffeisen: `/raiffeisen/bankszamla/`,
	unicredit: `/unicredit/bankszamla/`,
};

interface Props {
	title: string;
	variant: "mortgage" | "personalLoan" | "retailAccount";
}

interface State {
	wasVisible: boolean;
}

export class BankLogosCloud extends React.PureComponent<Props, State> {
	public constructor(props: Props) {
		super(props);

		this.state = { wasVisible: false };
	}

	@autobind
	private onVisibilityChange(wasVisible: boolean): void {
		if (wasVisible) {
			this.setState({
				wasVisible: true,
			});
		}
	}

	public render(): ReactNode {
		const { title } = this.props;
		const { wasVisible = false } = this.state;

		return (
			<InView
				as="div"
				className={`bank-logos-cloud text-center py-5${wasVisible ? "" : " bm-lazy"}`}
				{...GoogleAnalytics4.getInViewProps()}
				skip={wasVisible}
				onChange={this.onVisibilityChange}
			>
				<div className="h1 mb-sm-4 mb-4">{title}</div>
				<div className="bank-logos d-flex">{this.renderBankLogos()}</div>
			</InView>
		);
	}

	private renderBankLogos(): ReactNode {
		const keys = Object.keys(this.findLinkGroup());

		return keys.map(this.renderLogo);
	}

	@autobind
	private renderLogo(key: string): ReactNode {
		const targetUrl = this.findUrlforBankName(key);
		const title = this.findBankName(key);

		if (!targetUrl) {
			return <div title={title} key={key} className={`bank my-2 mx-3 ${key}`} />;
		}

		return (
			<a href={this.findUrlforBankName(key)} target="_blank" rel="noreferrer" title={title} key={key}>
				<div className={`bank my-2 mx-3 ${key}`} />
			</a>
		);
	}

	private findUrlforBankName(bankName: string): string {
		const keys = Object.keys(this.findLinkGroup());
		const bank = keys.find((key) => key === bankName);

		return this.findLinkGroup()[bank];
	}

	private findBankName(bankCode: string): string {
		const keys = Object.keys(bankNames);
		const bank = keys.find((key) => key === bankCode);

		return bankNames[bank];
	}

	private findLinkGroup(): any {
		const { variant } = this.props;

		switch (variant) {
			case "mortgage":
				return mortgageLinks;
			case "personalLoan":
				return personalLoanLinks;
			case "retailAccount":
				return retailAccountLinks;
			default:
				break;
		}
	}
}
